//AUTHENTICATIONS
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const IS_LOGGING_IN = 'IS_LOGGING_IN';
export const SET_MUST_CHANGE_PASSWORD = 'SET_MUST_CHANGE_PASSWORD';
//MFA
export const SET_NEED_MFA = 'NEED_MFA';
//SITE
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const IS_LOADING_GLOBAL = 'IS_LOADING_GLOBAL';
export const IS_LOADED_GLOBAL = 'IS_LOADED_GLOBAL';
export const SHOW_ALERT = 'SHOW_ALERT';
export const SHOW_ALERT_MODAL = 'SHOW_ALERT_MODAL';
export const HIDE_ALERT = 'HIDE_ALERT';
export const HIDE_ALERT_MODAL = 'HIDE_ALERT_MODAL';
export const CLEAN_SITE = 'CLEAN_SITE';
//DASHBOARD
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const DELETE_NOTE = 'DELETE_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const CREATE_NOTE = 'CREATE_NOTE';
export const UPDATE_ACTION_ITEM = 'UPDATE_ACTION_ITEM';
export const CLEAN_DASHBOARD = 'CLEAN_DASHBOARD';
export const UPDATE_LOADING_DASHBOARD = 'UPDATE_LOADING_DASHBOARD';
export const UPDATE_CALENDAR_EVENTS = 'UPDATE_CALENDAR_EVENTS';
//USER
export const GET_USER = 'GET_USER';
export const SET_USER_DATA = 'SET_USER_DATA';
export const CLEAN_USER = 'CLEAN_USER';
export const REFRESH_USER = 'REFRESH_USER';
export const IS_SENDING_INFORMATION = 'IS_SENDING_INFORMATION';
export const SET_COMPLETED_TOUR_SECTIONS = 'SET_COMPLETED_TOUR_SECTIONS';
//APPOINTMENTS
export const UPDATE_LOADING_APPOINTMENTS_DATA =
  'UPDATE_LOADING_APPOINTMENTS_DATA';
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS';
export const GET_CARRIERS = 'GET_CARRIERS';
export const SET_CARRIERS_ARRAY = 'SET_CARRIERS_ARRAY';
export const SET_STATEMENTS_CARRIERS_ARRAY = 'SET_STATEMENTS_CARRIERS_ARRAY';
export const GET_APPOINTED_CARRIERS = 'GET_APPOINTED_CARRIERS';
export const GET_REQUESTED_APPOINTMENTS = 'GET_REQUESTED_APPOINTMENTS';
export const CLEAN_APPOINTMENTS = 'CLEAN_APPOINTMENTS';
export const SET_VIEWING_AS = 'SET_VIEWING_AS';
export const RESET_VIEWING_AS = 'RESET_VIEWING_AS';
export const IS_SENDING_REQUEST_APPOINTMENTS =
  'IS_SENDING_REQUEST_APPOINTMENTS';
export const SET_REQUESTED_CARRIER_NAME = 'SET_REQUESTED_CARRIER_NAME';
export const SET_IS_NEO_SUBMISSION_MODAL_OPEN =
  'SET_IS_NEO_SUBMISSION_MODAL_OPEN';
export const IS_UPDATING_REQUEST_APPOINTMENTS =
  'IS_UPDATING_REQUEST_APPOINTMENTS';
export const GET_STATEMENT_PERIODS = 'GET_STATEMENT_PERIODS';
//MARKETING ANNOUNCEMENTS
export const GET_MARKETING_ANNOUNCEMENTS = 'GET_MARKETING_ANNOUNCEMENTS';
export const CLEAN_MARKETING_ANNOUNCEMENTS = 'CLEAN_MARKETING_ANNOUNCEMENTS';
//COMMISSIONS
export const GET_COMMISSIONS = 'GET_COMMISSIONS';
export const CLEAN_COMMISSIONS = 'CLEAN_COMMISSIONS';
export const IS_DOWNLOADING_REPORT = 'IS_DOWNLOADING_REPORT';
//LEADS
export const GET_LEADS = 'GET_LEADS';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const CLEAN_LEADS = 'CLEAN_LEADS';
//BONUS
export const GET_BONUS = 'GET_BONUS';
export const CLEAN_BONUS = 'CLEAN_BONUS';
//NOTIFICATIONS
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_PUSH_NOTIFICATIONS_AND_POP_UPS =
  'SET_PUSH_NOTIFICATIONS_AND_POP_UPS';
export const SET_POP_UP = 'SET_POP_UP';
export const CLEAN_NOTIFICATIONS = 'CLEAN_NOTIFICATIONS';
//AGENCY MANAGEMENT
export const SET_AGENCIES_TREE = 'SET_AGENCIES_TREE';
export const SET_AGENCY_DATA = 'SET_AGENCY_DATA';
export const RESET_AGENCY_DATA = 'RESET_AGENCY_DATA';
export const IS_UPDATING_PREFERENCES = 'IS_UPDATING_PREFERENCES';
export const IS_SENDING_ONBOARDING_FORM = 'IS_SENDING_ONBOARDING_FORM';
export const SET_MULTIPLE_AGENCIES_DATA = 'SET_MULTIPLE_AGENCIES_DATA';
export const RESET_MULTIPLE_AGENCIES_DATA = 'RESET_MULTIPLE_AGENCIES_DATA';

export const SET_AGENCY_DASHBOARD_AGENTS_DATA =
  'SET_AGENCY_DASHBOARD_AGENTS_DATA';
export const RESET_AGENCY_DASHBOARD_AGENTS_DATA =
  'RESET_AGENCY_DASHBOARD_AGENTS_DATA';
export const SET_AGENTS_APPOINTMENTS_COUNT = 'SET_AGENTS_APPOINTMENTS_COUNT';
export const SET_COMISSIONS_TAB_AGENTS = 'SET_COMISSIONS_TAB_AGENTS';
export const SET_INCLUDE_INACTIVE_AGENTS_IN_REPORT =
  'SET_INCLUDE_INACTIVE_AGENTS_IN_REPORT';

// Health Sherpa
export const UPDATE_AGENT_POLIICES_ARRAY = 'UPDATE_AGENT_POLIICES_ARRAY';
export const UPDATE_AGENT_POLICIES_COUNT = 'UPDATE_AGENT_POLICIES_COUNT';
//FAQS
export const GET_FAQS = 'GET_FAQS';
//Carrier FAQs
export const GET_CARRIER_FAQS = 'GET_CARRIER_FAQS';
export const CLEAR_CARRIER_FAQS = 'CLEAR_CARRIER_FAQS';
export const SET_CARRIER_FAQS_LOADER = 'SET_CARRIER_FAQS_LOADER';
export const SET_FAQS_BY_CARRIER = 'SET_FAQS_BY_CARRIER';
// Reconciliation Forms (Zoho Reconciliation_Forms)
export const GET_RECONCILIATION_FORMS = 'GET_RECONCILIATION_FORMS';
export const SET_RECONCILIATION_FORMS_LOADING =
  'SET_RECONCILIATION_FORMS_LOADING';
//Filters
export const SET_FILTERS = 'SET_FILTERS';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const DELETE_FILTER = 'DELETE_FILTER';
export const GET_FILTERS = 'GET_FILTERS';
// Marketing Assets
export const SET_MARKETING_ASSETS = 'SET_MARKETING_ASSETS';
export const SET_MARKETING_ASSETS_LOADER = 'SET_MARKETING_ASSETS_LOADER';
export const SET_MARKETING_ASSETS_ERROR = 'SET_MARKETING_ASSETS_ERROR';
